<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <ListaHotel />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import ListaHotel from "../Components/Listagens/ListaHotel.vue";
export default {
  name: "ListHotel",
  components: {
    ListaHotel,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>
